import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface CodeDTO {
  code: string;
}

export class Code {
  readonly isCodeCode: boolean = true;

  readonly code: string;

  static readonly constraints = {
    "code": {
      "maxSize": 100,
      
      
      
      
    }
  }

  constructor(
  code: string
  ) {
    Code.validateCode(code);
    this.code = code;
  }

  static fromDTO(dto: CodeDTO): Code {
    const code = getString(dto, "code", InvalidCodeCodeError);
    return new Code(
      code
    );
  }

  toDTO(): CodeDTO {
    const dto: CodeDTO = {
        code: this.code
    };
    return dto;
  }
  private static validateCode = (code: string): void => {
    if(code.length > 100) {
      throw new InvalidCodeCodeMaxSizeError(
        100,
        `Attribute code is too long. Size is ${code.length}. Max size is 100.`
      );
    }
      if(code.trim().length === 0) {
        throw new InvalidCodeCodeNonEmptyError(
          `Attribute code cannot be an empty string.`
        );
      }
  }
  
}

Code.prototype.toString = function toString(): string {
  return `Code(code='${this.code}')`;
};

export class InvalidCodeError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidCodeError";
  }
}
export class InvalidCodeCodeError extends InvalidCodeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidCodeCodeError";
  }
}

export class InvalidCodeCodeMaxSizeError extends InvalidCodeCodeError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidCodeCodeMaxSizeError";
  }
}

export class InvalidCodeCodeNonEmptyError extends InvalidCodeCodeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidCodeCodeNonEmptyError";
  }
}
